//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/**
 * Represents the type of push notification to use for the Interactive
 * Experience system when posting questions.
 */
export const InteractiveExperiencePushNotificationType = {
    /** A push notification is never sent when a question is posted. */
    Never: 0,

    /** A push notification is always sent when a question is posted. */
    EveryAction: 1,

    /**
     * The moderator decides if the push notification should be sent
     * when they post a question.
     */
    SpecificActions: 2
} as const;

/**
 * Represents the type of push notification to use for the Interactive
 * Experience system when posting questions.
 */
export const InteractiveExperiencePushNotificationTypeDescription: Record<number, string> = {
    0: "Never",

    1: "Every Action",

    2: "Specific Actions"
};

/**
 * Represents the type of push notification to use for the Interactive
 * Experience system when posting questions.
 */
export type InteractiveExperiencePushNotificationType = typeof InteractiveExperiencePushNotificationType[keyof typeof InteractiveExperiencePushNotificationType];
